import { useTranslations } from '@power-core/toolkit';

export const useCheckTranslatedString = () => {
	const t = useTranslations();

	const checkTranslatedString = (statusName: string | null | undefined): string => {
		return statusName ? t(statusName) : '';
	};

	return checkTranslatedString;
};
